import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { CreateSurvey } from 'app/dtos/survey/create-survey';
import { firstValueFrom, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  constructor(private httpClientService: HttpClientService) { }

  async createSurvey(createSurvey: CreateSurvey) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Survey
    }, createSurvey);
    return await firstValueFrom(observable);
  }

  async getAllSurvey(page, size) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Survey,
      queryString: `Page=${page}&Size=${size}`
    });
    return await firstValueFrom(observable);
  }

  async getByIdSurvey(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Survey
    }, id);
    return await firstValueFrom(observable);
  }

  async updateSurvey(id,name,description){
    const observable:Observable<any> = this.httpClientService.put({
      controller:ControllerType.Survey
    },{
      id:id,
      name:name,
      description:description
    });
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}